<template>
  <div class="post-page">
    <div class="w-1200">
      <div class="top-box">
        <el-form label-position="conter" :model="form" label-width="70px">
          <el-row>
            <el-col :span="5">
              <el-form-item label="关键词">
                <el-input v-model="form.keywords" placeholder="cas,英文名,中文名"/>
              </el-form-item>
            </el-col>
            <el-col :span="5" :offset="1">
              <el-form-item label="订单状态">
                <el-select v-model="form.status" placeholder="请选择状态">
                  <el-option label="进行中" :value="1"></el-option>
                  <el-option label="已到期" :value="2"></el-option>
                  <el-option label="已结束" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-form-item label="发布时间">
                <el-date-picker value-format="yyyy-MM-dd" v-model="form.created_at" type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4" class="flex-end">
              <gradient-button background="#0C60E6" @hit="handleSearch">搜索</gradient-button>
              <gradient-button color="#5F616C" border="1px solid #5F616C" background="transparent" @hit="handleReset">刷新
              </gradient-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="content-box">
        <div class="content-box-left">我的发布</div>
        <gradient-button background="#0C60E6" @hit="handleRelease">发布询单</gradient-button>
      </div>
      <div class="fotter-box">
        <div class="teble" v-loading="loading">
          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" border
                    :header-cell-style="{ backgroundColor: '#F6F6F8' }">
            <el-table-column fixed prop="id" label="序号" width="50">
            </el-table-column>
            <el-table-column prop="cas_no" label="CAS号">
              <template slot-scope="scope">
                <span>{{ scope.row.cas_no }}</span>
                <span class="color-doat" v-if="scope.row.not_read_count&&(scope.row.status==1||scope.row.status==2)">
                    {{ scope.row.not_read_count || 0 }}
                  </span>
              </template>
            </el-table-column>
            <el-table-column prop="product_name" label="产品名称">
              <template slot-scope="scope">
                <span>{{ scope.row.product_name || scope.row.alias_name || '' }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="name_en" width="200" label="英文名称"></el-table-column>
            <el-table-column prop="number" label="需求量">
              <template slot-scope="scope">
                <span>{{ scope.row.number }} {{ scope.row.unit }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status == '1'" type="success">进行中0人已报价</el-tag>
                <el-tag v-else-if="scope.row.status == '2'" type="success">进行中 {{
                    scope.row.quote_count
                  }}人已报价
                </el-tag>
                <el-tag v-else-if="scope.row.status == '-1'||scope.row.status == '3'" type="info">已结束</el-tag>
                <el-tag v-else-if="scope.row.status == '-2'" type="danger">已到期</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="begin_at" label="发布时间">
            </el-table-column>
            <el-table-column prop="end_at" label="到期时间"></el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <div class="operation">
                  <el-button v-if="scope.row.status > 0" @click="lookDetail(scope.row)" type="text" size="small">查看
                  </el-button>
                  <el-button type="text" size="small" @click="quote(scope.row)">再次发布</el-button>
                  <el-button type="text" @click="endQuote(scope.row)" size="small"
                             v-if="scope.row.status >0&&scope.row.status != '3'">结束
                  </el-button>
                  <el-button type="text" size="small" @click="quoteHistory(scope.row.cas_no)">历史报价</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-box">
          <el-pagination class="float-right" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" background
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 报价弹窗 -->
    <Post_Inquiry :dialogVisible="showRest" @close="closeInquiry"></Post_Inquiry>
    <!-- 采购订单详情 -->
    <OrderLook :detailVisible="detailVisible" :dataInfo="lookData" @updateStatus="updateStatus"></OrderLook>
    <!-- 采购订单报价历史 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               :visible.sync="quoteHistoryVisible" width="900px" title="采购订单报价历史"
               :before-close="quoteHistoryClose">
      <div class="quote-history-box">
        <el-table class="quote-history-table" :data="quoteHistoryData" border
                  :header-cell-style="{ backgroundColor: '#D1E1FB' }">
          <el-table-column prop="number" label="需求量">
            <template slot-scope="scope">
              <span>{{ scope.row.number }} {{ scope.row.unit }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="purity" label="纯度">
            <template slot-scope="scope">
              <span>{{ scope.row.purity }}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="total_price" v-if="userInfo.vip_status == 1" label="总价"/>
          <el-table-column prop="custorm_price" label="总价" v-else/>
          <el-table-column prop="is_quote" label="现货">
            <template slot-scope="scope">
              <span>{{ scope.row.is_quote == 1 ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stock_day" label="备货天数"/>
          <el-table-column prop="invoice_type" label="开票类型">
            <template slot-scope="scope">
              <span>{{
                  scope.row.invoice_type == 1 ? "专票(13%)" : "普票"
                }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination class="float-right" @size-change="quoteHistorySizeChange"
                         @current-change="quoteHistoryCurrentChange" :current-page="quoteHistoryPage"
                         :page-sizes="[10, 20, 30, 40]"
                         :page-size="quoteHistoryPageSize" background layout="total, sizes, prev, pager, next, jumper"
                         :total="quoteHistoryTotal">
          </el-pagination>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import gradientButton from "@/components/button/gradient-button.vue";
import {
  purchaseList,
  purchaseDetail,
  quote_history,
  quote_list_api,
  purchaseAdd,
  end_quote,
} from "@/api/modules/user";
import Post_Inquiry from "../../../components/addInfo/post_Inquiry.vue";
import OrderLook from "@/components/orderLook/orderLook.vue";


export default {
  components: {Post_Inquiry, gradientButton, OrderLook},
  name: "post",

  data() {
    return {
      showRest: false,
      loading: false,
      total: 0,
      page: 1,
      pageSize: 10,
      quoteHistoryTotal: 0,
      quoteHistoryPage: 1,
      quoteHistoryPageSize: 10,
      input: "",
      form: {
        keywords: "",
        created_at: [],
        status: "",
      },
      tableData: [],
      // 查看弹窗和内容
      detail: {},
      detailVisible: false,
      // 报价历史弹窗和内容
      quoteHistoryData: [],
      quoteHistoryVisible: false,
      // 报价弹窗和内容
      quoteVisible: false,
      quoteForm: {
        cas_no: "",
        number: "",
        unit: "",
      },
      // 采购订单查看报价列表
      cas_no_quoteList: [],
      lookData: {},
    };
  },
  computed: {
    userInfo() {
      let data = this.$store.getters.userInfo;
      return data
    }
  },

  // 如果使用了 keep-alive，组件激活时执行
  mounted() {
    // 只有在非首次加载时才刷新数据，避免与mounted重复请求
    this.getList();

  },
  methods: {
    // 输入防抖处理
    onInput() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        // 可以在这里添加输入验证逻辑
      }, 300);
    },

    // 成为vip
    getVip() {
      this.$router.push({path: '/vip/vip'});
    },
    handleQuote(row) {
      this.quoteVisible = true;
      this.quoteForm = row;
      this.$router.push({
        path: "/user/purchase/bay",
        query: {id: row.id},
      });
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    // 刷新
    handleReset() {
      this.form = {
        keywords: "",
        created_at: [],
        status: "",
      };
      this.getList();
    },
    // 获取采购订单列表
    getList() {
      this.loading = true;
      let data = this.form;
      data.page = this.page;
      data.limit = this.pageSize;
      purchaseList(data).then((res) => {
        if (res.data.code == 10000) {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
          this.loading = false;
        }
      });
    },
    // 发布采购
    handleRelease() {
      // this.showRest=true
      /**
       * 2026-01-10 修改注册流程
       * if (this.mixCheckUserAudit()) {
       *  this.$router.push("/user/purchase/release");
       *}
       *
       */
      if (this.mixCheckUserMobile()) {
        this.$router.push("/user/purchase/release");
      }
    },
    closeInquiry() {
      this.showRest = false
    },
    // 查看详情
    lookDetail(row) {
      this.lookData = row
      this.detailVisible = true;
      this.$store.dispatch('GET_USER_COUNT').catch(error => {
        console.error('获取用户统计数据失败:', error);
      });
      this.getList()
    },
    updateStatus(e) {
      this.detailVisible = e
    },
    // 获取采购订单报价历史
    quoteHistory(cas) {
      quote_history(cas).then((res) => {
        if (res.data.code == 10000) {
          this.quoteHistoryData = res.data.data.data;
          this.quoteHistoryVisible = true;
          this.quoteHistoryTotal = res.data.data.total;
        }
      });
    },
    // 关闭报价历史弹窗
    quoteHistoryClose() {
      this.quoteHistoryVisible = false;
    },
    // 报价历史分页
    quoteHistorySizeChange(val) {
      this.quoteHistoryPageSize = val;
      this.quoteHistoryGetList();
    },
    // 报价历史分页
    quoteHistoryCurrentChange(val) {
      this.quoteHistoryPage = val;
      this.quoteHistoryGetList();
    },
    // 报价
    quote(item) {
      this.$router.push({
        path: "/user/purchase/release",
        query: {id: item.id},
      });
    },
    // 结束报价
    endQuote(item) {
      this.$confirm("确定结束报价吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        end_quote(item.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
            this.getList();
          } else {
            this.$message.error({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
          }
        });
      });
    },
    // 关闭报价弹窗
    quoteClose() {
      this.quoteVisible = false;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped lang="scss">
.color-doat {
  display: inline-block;
  color: #ffffff;
  background: red;
  width: 17px;
  height: 17px;
  line-height: 17px;
  font-size: 11px;
  border-radius: 50%;
  text-align: center;
  transform: translateX(80%);
}

.quote-history-box {
  .pagination-box {
    text-align: right;
    padding: 20px 0;
  }
}

.add-box-account {
  .table-title {
    font-weight: 500;
    font-size: 18px;
    color: #00112b;
    line-height: 25px;
    margin: 20px 0 10px;
  }

  .vip-tag {
    margin-left: 10px;
    width: 50px;
    vertical-align: middle;
  }
}

.table-box {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .img-box {
    height: 160px;
    width: 220px;
    margin-right: 20px;

    img {
      width: 220px;
      height: 120px;
    }
  }
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  /* 关键：合并边框 */
  border-color: #f3f3f3;

  /* 新增样式规则 */
  td:nth-child(1),
  td:nth-child(3) {
    width: 100px;
    height: 40px;
    background: #f9faff;
    text-align: center;
    line-height: 40px;
    color: #5f616c;
  }

  td:nth-child(2),
  td:nth-child(4) {
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #f3f3f3;
    color: #00112b;
  }
}

.post-page {
  padding-bottom: 100px;

  .top-box {
    ::v-deep .el-form-item {
      margin-bottom: 0;
    }

    ::v-deep .el-date-editor--daterange.el-input,
    .el-date-editor--daterange.el-input__inner,
    .el-date-editor--timerange.el-input,
    .el-date-editor--timerange.el-input__inner {
      width: 15vw;
    }

    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    padding: 30px;
    box-sizing: border-box;

    .input-box {
      display: flex;
      align-items: center;

      .input-title {
        width: 108px;
        font-weight: 400;
        font-size: 18px;
        color: #00112b;
        line-height: 25px;
      }

      .custom-input {
        width: 300px;

        ::v-deep .el-input__inner {
          height: 50px;
          line-height: 50px;
          border-radius: 4px;
          border-color: #dcdfe6;

          &:hover,
          &:focus {
            border-color: #409eff;
          }
        }
      }

      ::v-deep .el-date-editor.el-input {
        width: 300px;
      }
    }

    .line {
      height: 27px;
    }
  }

  .content-box {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
    padding: 20px 0 22px;

    .content-box-left {
      font-weight: 800;
      font-size: 20px;
      color: #00112b;
    }
  }

  .fotter-box {
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    margin-bottom: 100px;
    padding: 20px;

    .operation {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .el-button {
        font-weight: 500;
        //font-size: 16px;
      }
    }
  }

  .pagination-box {
    padding-top: 20px;
    padding-left: 60px;

    .float-right {
      text-align: right;
    }
  }

  .button-group {
    justify-content: flex-end;

    .search-btn {
      margin-right: 15px;
    }

    .reset-btn {
      margin-left: 30px;
      width: 120px;
      height: 50px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #5f616c;
      font-weight: 400;
      font-size: 18px;
      color: #5f616c;
    }
  }
}
</style>
